'use client';

import { useSyncExternalStore } from 'react';

function subscribe(query: string, onStoreChange: () => void): () => void {
  const mediaQuery = window.matchMedia(query);
  mediaQuery.addEventListener('change', onStoreChange);
  return () => mediaQuery.removeEventListener('change', onStoreChange);
}

function getSnapshot(query: string): boolean {
  return window.matchMedia(query).matches;
}

/**
 * Subscribe to a CSS media query. SSR / first client render uses `serverSnapshot`
 * (default `false`) to avoid hydration mismatches.
 */
export function useMatchMedia(
  query: string,
  serverSnapshot = false,
): boolean {
  return useSyncExternalStore(
    (onStoreChange) => subscribe(query, onStoreChange),
    () => getSnapshot(query),
    () => serverSnapshot,
  );
}
